import QuizHeader from "./Header";
import { trans } from "../Lang";
import { Link } from "react-router-dom";
import React from "react";

export function QuizRecap(props) {
    const quizResult = props.location.state.quiz_result
    return (
        <div>
            <QuizHeader data={quizResult} />
            <div className="bg-orange pad-m pad-xl">
                <div className="container-small">
                    <h3 className="font-white font-light mb-m">
                        Review kembali materi {trans.course} yang ada untuk memperluas pemahaman
                    </h3>
                    <h5 className="font-white font-light">
                        Anda menjawab {quizResult.correct_answer_count} dari {quizResult.question_count} pertanyaan dengan benar
                    </h5>
                </div>
            </div>
            <div className="bg-white pad-m pad-l">
                <div className="container-small">
                    {quizResult.correct_questions.length > 0 && (
                        <div>
                            <h5>Yang sudah Anda pahami</h5>
                            <ul className="strip-list mb-m">
                                {quizResult.correct_questions.map((item, i) => {
                                    item = item.replace(/<img[^>]*>/g, '');
                                    return (<li dangerouslySetInnerHTML={{ __html: item }}></li>)
                                })}
                            </ul>
                        </div>
                    )}

                    {quizResult.incorrect_questions.length > 0 && (
                        <div>
                            <h5>Yang harus Anda Pelajari Lagi</h5>
                            <ul className="strip-list">
                                {quizResult.incorrect_questions.map((item, i) => {
                                    item = item.replace(/<img[^>]*>/g, '');
                                    return (<li dangerouslySetInnerHTML={{ __html: item }}></li>)
                                })}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
            <div className="pad-m pad-l align-right container">
                <Link
                    className="btn capitalize full-s"
                    to={`/quiz/result/${quizResult.quiz_uuid}`}
                >
                    Kembali ke hasil kuis
                </Link>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/Quiz/Recap.js